import React, { useEffect, useState } from "react";

const Weather = () => {
    const [weather, setWeather] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const API_KEY = "9fb9e5000909703ba762f0464aef5314";
    const CITY = "Melbourne,AU";

    useEffect(() => {
        const fetchWeather = async () => {
            try {
                const res = await fetch(
                    `https://api.openweathermap.org/data/2.5/weather?q=${CITY}&units=metric&appid=${API_KEY}`
                );
                if (!res.ok) throw new Error("Failed to fetch weather");
                const data = await res.json();
                const temp = Math.round(data.main.temp);
                const condition = data.weather[0].description;
                setWeather({ temp, condition });
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchWeather();
    }, []);

    if (loading) return <div className="c-splash__weather">Loading weather...</div>;
    if (error) return <div className="c-splash__weather">Error: {error}</div>;

    return (
        <div className="c-splash__weather">
            Currently {weather.temp}°C,{" "}
            {weather.condition.charAt(0).toUpperCase() + weather.condition.slice(1)}
        </div>
    );
};

export default Weather;
